import React, { CSSProperties, MouseEventHandler, useMemo } from 'react';
import { TableCell, Tooltip } from '@mui/material';
import { type SxProps, type Theme } from '@mui/material/styles';

export interface AccountOperationCellWithTooltipProps {
  /**
   * If the end of the value is between parenthesises, it will be displayed as a tooltip.
   */
  value: string;

  sx?: SxProps<Theme>;

  style?: CSSProperties;

  onClick?: MouseEventHandler<HTMLDivElement>;
  onDoubleClick?: MouseEventHandler<HTMLDivElement>;
}

export const AccountOperationCellWithTooltip = (
  props: AccountOperationCellWithTooltipProps,
) => {
  const { sx, style, onClick, onDoubleClick, value } = props;

  const [cellValue, tooltipValue] = useMemo(() => {
    const match = value.trim().match(/^([^(]*)(?:\(([^)]*)\))?$/);
    if (match) {
      return [match[1], match[2]];
    } else {
      return [value, undefined];
    }
  }, [value]);

  return (
    <Tooltip
      arrow={true}
      open={tooltipValue != null ? undefined : false}
      title={tooltipValue ?? ''}
    >
      <TableCell
        component={'div'}
        sx={sx}
        style={style}
        onClick={onClick}
        onDoubleClick={onDoubleClick}
      >
        {cellValue}
      </TableCell>
    </Tooltip>
  );
};
